import { LeftOutlined } from '@ant-design/icons'
import TermContent from 'web/TermContent/TermContent'
import { isMobile } from 'react-device-detect'
import './Term.scss'
import { HOME } from 'configs/path'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { bindParams } from 'utilities/helpers'
import { useAppSelector } from 'hooks'
import { Helmet } from 'react-helmet'
const TermPage = () => {
  const { t } = useTranslation()
  const { app_id, setting } = useAppSelector((s) => s.app)

  return (
    <div className="term-page">
      <Helmet>
        <title>{setting?.app_name}</title>
      </Helmet>
      {isMobile && (
        <div className="term-header">
          <Link
            to={bindParams(HOME, {
              app: app_id
            })}
          >
            <LeftOutlined />
          </Link>
          <p>{t('term')}</p>
        </div>
      )}
      <TermContent />
    </div>
  )
}

export default TermPage
